module.exports = "<div ui-view layout-fill></div>"